import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import './App.css';
import trackingStore from './stores/TrackingStore';
import LandingPage from './pages/LandingPage';
import ContactPage from './pages/ContactPage';
import {lightTheme} from './themes/EarPhysicsTheme';
import NewsPage from './pages/news/NewsPage';
import TermsOfServicePage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import AboutPage from './pages/AboutPage';
import SignUpPage from './pages/SignUpPage';
import SignInPage from './pages/SignInPage';
import ProductListPage from './pages/ProductListPage';
import ProductDetailsPage from './pages/ProductDetailsPage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import OrderConfirmationPage from './pages/OrderConfirmationPage';
import MFA from './pages/MFA';
import VerifyEmail from './pages/VerifyEmail';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import Article from './pages/news/Article';
import UserProfilePage from './pages/UserProfilePage';
import OrderHistoryPage from './pages/OrderHistoryPage';
import OrderDetailsPage from './pages/OrderDetailsPage';
import RegisteredDevicesPage from './pages/RegisteredDevicesPage';
import PreorderPage from './pages/PreorderPage';
import { CampaignProvider } from './contexts/CampaignContext';
import { ExperimentProvider } from './contexts/ExperimentContext';
import { trackPageview } from './handlers/analytics';
import SeoHead from './components/SeoHead';
import FomoToasts from './components/FomoToasts';
import HeatmapTracker from './components/HeatmapTracker';
import ChatWidget from './components/ChatWidget';

function App() {
  // Capture ?promo= and ?ref= from URL on first load
  useEffect(() => {
    trackingStore.captureFromUrl();
  }, []);

  const ScrollToTop = () => {
    const location = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [location]);

    return null;
  };

  // First-party, cookieless pageview tracking on every route change.
  const AnalyticsTracker = () => {
    const location = useLocation();

    useEffect(() => {
      trackPageview(location.pathname);
    }, [location.pathname]);

    return null;
  };

  return (
    <ThemeProvider theme={lightTheme}>
      <Router>
        <CampaignProvider>
          <ExperimentProvider>
          <ScrollToTop />
          <AnalyticsTracker />
          <SeoHead />
          <FomoToasts />
          <HeatmapTracker />
          <ChatWidget />
          <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/news/:article" element={<Article />} />
          <Route path="*" element={<LandingPage />} />
          <Route path="/terms" element={<TermsOfServicePage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/sign-in" element={<SignInPage />} />
          <Route path="/sign-in/mfa" element={<MFA />} />
          <Route path="/sign-up" element={<SignUpPage />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/products" element={<ProductListPage />} />
          <Route path="/products/:id" element={<ProductDetailsPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/order-confirmation" element={<OrderConfirmationPage />} />
          <Route path="/profile" element={<UserProfilePage />} />
          <Route path="/preorder" element={<PreorderPage />} />
          <Route path="/order-history" element={<OrderHistoryPage />} />
          <Route path="/devices" element={<RegisteredDevicesPage />} />
          <Route path="/orders/:orderId" element={<OrderDetailsPage />} />
          </Routes>
          </ExperimentProvider>
        </CampaignProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
